import { useMemo } from "react";
import { useAppSelector } from "../../framework/redux/hooks";
import {
    makeSelectPlannedWorkShiftsByDate,
    makeSelectPlannedWorkShiftsDurationByDate,
} from "../../framework/redux/slices/plannedWorkShiftSlice";

export const useSelectPlannedWorkShiftsByDate = (
    rangeStart: string,
    rangeEnd: string
) => {
    const state = useAppSelector((state) => state.plannedWorkShift);

    const selectWorkShiftsByDate = useMemo(
        makeSelectPlannedWorkShiftsByDate,
        []
    );
    return selectWorkShiftsByDate(state, rangeStart, rangeEnd);
};

export const useSelectPlannedWorkShiftsDurationByDate = (
    rangeStart: string,
    rangeEnd: string
) => {
    const state = useAppSelector((state) => state.plannedWorkShift);

    const selectWorkShiftsDurationByDate = useMemo(
        makeSelectPlannedWorkShiftsDurationByDate,
        []
    );
    return selectWorkShiftsDurationByDate(state, rangeStart, rangeEnd);
};
